@if(!isShowMainBlock && !showDetailsBlock){

<div>
  <div class="air-details-container">
    <div class="section-title">
      Inspector Open TLR Report - Build Search
    </div>
    <div class="partioned-table">
      <div class="row" *ngIf="showDateRange">
        <div class="cell label label-text">Date Range
        </div>
        <div class="cell value"> <p-checkbox label="Last 7 Days" [(ngModel)]="filters.Last7DaysFlag" binary="true"> 

          </p-checkbox>
          <ng-container *ngIf="!filters.Last7DaysFlag">
            <div class="date-row">
              <span class="date-label">Start Date:</span>
              <p-calendar [showIcon]="true" [(ngModel)]="filters.StartDate" dateFormat="mm/dd/yy"
                [style]="{'width':'20%'}"></p-calendar>
            </div>
            <div class="date-row">
              <span class="date-label">To Date:</span>
              <p-calendar [showIcon]="true" [(ngModel)]="filters.EndDate" dateFormat="mm/dd/yy"
                [style]="{'width':'20%'}"></p-calendar>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Repair Type
        </div>
        <div class="cell value"> <p-dropdown [options]="repairTypes" [(ngModel)]="filters.RepairTypeName"
            placeholder="ALL" class="dropdown" class="custom-dropdown" panelStyleClass="custom-dropdown-panel"
            optionLabel="name" optionValue="value" ></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Division
        </div>
        <div class="cell value">
          <p-dropdown [options]="divisions" [(ngModel)]="filters.DivisionName" placeholder="ALL" class="dropdown"
            class="custom-dropdown"  optionLabel="name" optionValue="value"></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Section
        </div>
        <div class="cell value">
          <p-dropdown [options]="section" [(ngModel)]="filters.SectionName" placeholder="ALL" class="dropdown"
            class="custom-dropdown"  optionLabel="name" optionValue="value"></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Plant
        </div>
        <div class="cell value">
          <p-dropdown [options]="plant" [(ngModel)]="filters.PlantName" placeholder="ALL" class="dropdown"
            class="custom-dropdown"  optionLabel="name" optionValue="value"></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Associated Plant - Shut down
        </div>
        <div class="cell value">
          <p-dropdown [options]="associatedUnit" [(ngModel)]="filters.AssocPlantShutdown" placeholder="ALL"
            class="dropdown" class="custom-dropdown"  optionLabel="name" 
            optionValue="value"></p-dropdown>
        </div>
      </div>


      <div class="row">
        <div class="cell label label-text">LDAR
        </div>
        <div class="cell value">
          <p-dropdown [options]="ldar" [(ngModel)]="filters.LDARFlag" placeholder="ALL" class="dropdown"
            class="custom-dropdown"  optionLabel="name" optionValue="value"></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Component
        </div>
        <div class="cell value">
          <p-dropdown [options]="manageLeaksItems" [(ngModel)]="filters.manageLeaksItems" placeholder="ALL"
            class="dropdown" class="custom-dropdown"  optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Vapor/Liquid
        </div>
        <div class="cell value">
          <p-dropdown [options]="materialStateItems" [(ngModel)]="filters.materialStateItems" placeholder="ALL"
            class="dropdown" class="custom-dropdown"  optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Inspector User
        </div>
        <div class="cell value">
          <input style="width: 100%;" pInputText id="inspectorCai" type="text" [(ngModel)]="filters.InspCAI" maxlength="100" class="user-id-input">

        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Services
        </div>
        <div class="cell value">
          <div class="services-option" *ngFor="let service of services">
            <p-checkbox [inputId]="service.value" name="services.name" [value]="service.value"
              [(ngModel)]="filters.Service"></p-checkbox>
            <label [for]="service.name">{{service.name}}</label>
          </div>
        </div>
      </div>

    </div>
    <div class="button-row">
      <button class="cursor-pointer" (click)="runReport()">Run Report</button>
    </div>
  </div>
</div>
}
@if(isShowMainBlock && !showDetailsBlock){
  <div class="section-sub-title text-bold">Inspector Open TLR Report Results</div>
  <div class="content-block">
    <div class="criterion-main-block">

      <div class="criterion-block">
        <p class='heading'>Criterion</p>

        <ul class="criterion-list">
          <li>Facility:{{reportService.getCurrentFacilityId()}}</li>
          <li>Date: {{formatDate(filters.StartDate)}} / {{formatDate(filters.EndDate)}}</li>
          <li>Repair Type: {{filters.RepairTypeName}}</li>
          <li>Division:{{filters.DivisionName}}</li>
          <li>Section: {{filters.SectionName}}</li>
          <li>Plant: {{filters.PlantName}}</li>
          <li>Associated Plant - S/D: {{filters.AssocPlantShutdown}}</li>
          <li>LDAR: {{filters.LDARFlag}}</li>
          <li>Component: {{filters.manageLeaksItems}}</li>
          <li>Material State:{{filters.materialStateItems}}</li>
          <li>Services: {{filters.Service.length ? filters.Service.join('|') : 'ALL'}}</li>
          <li>Inspector CAI:{{filters.InspCAI || 'ALL'}}</li>
        </ul>

      </div>
      <div >
        <p-table [value]="tlrStatusReport" [paginator]="false" responsiveLayout="scroll" width="50%">
          <ng-template pTemplate="header">
            <tr>
              <th>TLR Status</th>
              <th>Count</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                @if(item.TitleNumber> 0){

                <a class="Clickable" (click)="getDetails(item.TitleName)">{{item.TitleName}}</a>
                }
                @else{
                <span>{{item.TitleName}}</span>
                }
              </td>
              <td>{{item.TitleNumber}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr class="total-sections-row">

            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="chart-block" >
      <p-chart type="bar" [data]="chartData" [options]="chartOptions" [plugins]="plugins" class="chart"
        (onDataSelect)="selectData($event)"></p-chart>
    </div>
  </div>
}

@if(showDetailsBlock){
<div class="content-details-block">
  <div>
    <div class="report-header">
      <div>
        <div class="section-sub-title text-bold">Inspector Open TLR Report </div>

        <div class="section-sub-title"> <span class="">{{getFullTitle(titleName)}} </span></div>
        <div>Dates Selected:
          <span class="text-bold">{{filters.StartDate | date:'MM/dd/YYYY'}} </span>
          to <span class="text-bold">{{filters.EndDate | date:'MM/dd/YYYY'}}</span>
          Repair Type: <span class="text-bold">{{filters.RepairTypeName}}</span>
          Division: <span class="text-bold"> {{filters.DivisionName}} </span>
          Section: <span class="text-bold">{{filters.SectionName}}</span>
          Plant:<span class="text-bold">{{filters.PlantName}} </span>
          Associated Plant - S/D:<span class="text-bold">{{filters.AssocPlantShutdown}}</span>
          LDAR: <span class="text-bold">{{filters.LDARFlag}}</span>
          Component:<span class="text-bold">{{filters.manageLeaksItems}} </span>
          Material State:<span class="text-bold">{{filters.materialStateItems}} </span>
          Services:<span class="text-bold">{{filters.Service.length ? filters.Service.join('|') : 'ALL' }}</span>
          Inspector User Id:<span class="text-bold">{{filters.InspCAI || 'ALL'}} </span>
        </div>
      </div>
      <div>
        <p-button styleClass="p-button-secondary" (click)="GetInspectOpenTLRReportExcel()"> Export to
          Excel</p-button>
      </div>
    </div>
    <p-table [value]="stausReportDataDetails" [paginator]="true" [rows]="20" responsiveLayout="scroll" width="50%">
      <ng-template pTemplate="header">
        <tr>
          <th>Tag Number</th>
          <th> Entry Date</th>
          <th>Op. User ID</th>
          <th>Division</th>
          <th>Section</th>
          <th>Plant</th>
          <th>LDAR</th>
          <th>Op. PSI</th>
          <th>Op. Temp</th>
          <th> ShutdownDescription</th>
          <th>Service</th>
          <th>Insp. User ID</th>
          <th>Service Class </th>
          <th>OA User ID </th>
          <th>Permanent Repair Date </th>
          <th>Eng. User ID </th>
          <th>TLR Type </th>
          <th>Maximo WO Number </th>
          <th>Maximo Outage-T/A</th>

        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>

        <tr>
          <td>
            <a class="Clickable" routerLink="/details-section/{{item.Tag_Number}}">{{item.Tag_Number}}</a>
          </td>
          <td>{{item.Data_Entry_Date | date : 'MM/dd/YYYY'}}</td>
          <td>{{item.Operator_CAI}}</td>
          <td>{{item.Division}}</td>
          <td>{{item.Section}}</td>
          <td>{{item.Plant}}</td>
          <td>{{item.LDAR}}</td>
          <td>{{item.Oper_PSI}}</td>
          <td>{{item.Oper_Temp}}</td>
          <td>{{item.ShutdownDescription}}</td>
          <td>{{item.Service}}</td>
          <td>{{item.InspectionCAI}}</td>
          <td>{{item.ServiceClass}}</td>
          <td>{{item.OACAI}}</td>
          <td [ngClass]="getDateClass(item.Permanent_Repair_Date)">{{item.Permanent_Repair_Date | date : 'MM/dd/YYYY'}}
          </td>
          <td>{{item.EngineeringCAI}}</td>
          <td>{{item.TLRType}}</td>
          <td>{{item.Maximo_WO_Number}}</td>
          <td>{{item.Maximo_Outage_T_A}}</td>

        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr class="total-sections-row">

        </tr>
      </ng-template>
    </p-table>

  </div>
</div>
}
